import { Upload } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import * as React from 'react';

const Component: React.FunctionComponent<UploadProps> = props => {
  return <Upload.Dragger {...props} />;
};

export default Component;
